import { createSelector } from '@ngrx/store'
import * as SelectedProfileSelectors from 'libs/gb-front/selected-profile/data-access/src/lib/+state/selected-profile.selectors'
import * as BaseEventTicketsSelectors from 'libs/shared/event-tickets/data-access/src/lib/+state/base-event-tickets.selectors'

/**
 * Returns if the selected event ticket profile does not match the selected profile (if logged in)
 */
export const selectedEventTicketProfileMismatch = createSelector(
  BaseEventTicketsSelectors.selectedEventTicket,
  SelectedProfileSelectors.getSelectedProfile,
  (eventTicket, profile) => profile && ![profile.email, profile.invite_email].includes(eventTicket?.profile?.email),
)
